import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Chip, Stack, Typography } from '@mui/material';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import UserService from 'src/services/user/UserService';
import { AppState } from 'src/store';
import { usePreferedDateFormat } from 'src/util/DateFormatter';

const Cards: any = (data: any) => {
  // Newly added Accordions for Audit History
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const userService = UserService.getInstance();
  const handleChangeAccordion = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const { preferedDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const valueFormattedDate = String(data.data.date_time_of_change).split('T')[0].split('-');
  const valueFormattedTime = String(data.data.date_time_of_change).split('T')[1].split(':');
  const time = valueFormattedTime[0] > '12' ? parseInt(valueFormattedTime[0]) - 12 : valueFormattedTime[0];
  const meridiem = valueFormattedTime[0] > '12' ? 'PM' : 'AM';
  // const date = `${valueFormattedDate[1]}/${valueFormattedDate[2]}/${valueFormattedDate[0]}  ${time}:${valueFormattedTime[1]} ${meridiem}`;
  const date = `${preferedDateFormat(data.data.date_time_of_change?.split('T')[0])}  ${time}:${
    valueFormattedTime[1]
  } ${meridiem}`;

  return (
    <>
      {data.data.reason_data_changed === 'Data Entry' && data.data.changed_data !== 'None' ? (
        <Accordion
          disabled={false}
          expanded={expanded === 'panel1'}
          onChange={handleChangeAccordion('panel1')}
          className="CustomAccordion-AH"
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
            <Box>
              <Stack spacing={1.5} direction="row" sx={{ alignItems: 'center', mb: 1 }}>
                <Typography variant="h6" component="div">
                  <strong>{documentDetail.data[0].tmf_document_name}:</strong>{' '}
                  {data.data.field_changed ? `${data.data.field_changed}` : ''}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <span>{date}</span>
                </Typography>
                <Chip label={data.data.reason_data_changed} color="success" size="small" />
              </Stack>
              <Typography component="div" gutterBottom variant="body2">
                <strong>Data Entered:</strong> {data.data.changed_data === 'None' ? '' : data.data.changed_data}
              </Typography>
              <Typography component="div" gutterBottom variant="body2">
                {/* {`Entered By: ${userService.getUserName()}`} */}
                <strong>Entered By:</strong> {` ${data.data.created_by}`}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2"><strong>Field:</strong> {data.data.field_changed} </Typography>
          </AccordionDetails>
        </Accordion>
      ) : data.data.reason_data_changed === 'Document Access' ? (
        <Accordion
          disabled
          expanded={expanded === 'panel1'}
          onChange={handleChangeAccordion('panel1')}
          className="CustomAccordion-AH"
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
            <Box>
              <Stack spacing={1.5} direction="row" sx={{ alignItems: 'center', mb: 1 }}>
                <Typography variant="h6" component="div">
                  {documentDetail.data[0].tmf_document_name}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <span>{date}</span>
                </Typography>
                <Chip label={data.data.reason_data_changed} color="success" size="small" />
              </Stack>
              <Typography component="div" gutterBottom variant="body2">
                Accessed Document
              </Typography>
              <Typography component="div" gutterBottom variant="body2">
                {/* {`User: (${userService.getUserName()})`} */}
                <strong>User:</strong> {data?.data?.created_by}
              </Typography>
            </Box>
          </AccordionSummary>
        </Accordion>
      ) : data.data.reason_data_changed === 'Data Change' ? (
        <Accordion
          disabled
          expanded={expanded === 'panel1'}
          onChange={handleChangeAccordion('panel1')}
          className="CustomAccordion-AH"
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
            <Box>
              <Stack spacing={1.5} direction="row" sx={{ alignItems: 'center', mb: 1 }}>
                <Typography variant="h6" component="div">
                  {documentDetail.data[0].tmf_document_name}:{' '}
                  {data.data.field_changed ? `${data.data.field_changed}` : ''}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <span>{date}</span>
                </Typography>
                <Chip label={data.data.reason_data_changed} color="success" size="small" />
              </Stack>
              <Typography component="div" gutterBottom variant="body2">
                <strong>Data Changed:</strong> Value changed from &quot;
                {data.data.data_changed_from === 'None' ? ' ' : data.data.data_changed_from}&quot; to &quot;
                {data.data.changed_data === 'None' ? ' ' : data.data.changed_data}&quot;
              </Typography>
              <Typography component="div" gutterBottom variant="body2">
                <strong>Entered By:</strong> {`${data.data.created_by}`}
              </Typography>
            </Box>
          </AccordionSummary>
        </Accordion>
      ) : data.data.reason_data_changed === 'Comments' ? (
        <Accordion
          disabled
          expanded={expanded === 'panel1'}
          onChange={handleChangeAccordion('panel1')}
          className="CustomAccordion-AH"
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
            <Box>
              <Stack spacing={1.5} direction="row" sx={{ alignItems: 'center', mb: 1 }}>
                <Typography variant="h6" component="div">
                  {documentDetail.data[0].tmf_document_name}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <span>{date}</span>
                </Typography>
                <Chip label={data.data.reason_data_changed} color="success" size="small" />
              </Stack>
              {data?.data?.field_changed?.toLowerCase() === 'contents' && (
                <Typography component="div" gutterBottom variant="body2">
                  {data?.data?.is_reply
                    ? 'Replied to Comment: "' + data?.data?.changed_data + '"'
                    : 'Added Comment: "' + data?.data?.changed_data + '"'}
                </Typography>
              )}
              {/* {data?.data?.field_changed?.toLowerCase() !== 'contents' && (
                <Typography component="div" gutterBottom variant="body2">
                  Report Sent To Rajuli Lall (CTM)
                </Typography>
              )} */}
              <Typography component="div" gutterBottom variant="body2">
                <strong>Entered By:</strong> {` ${data.data.created_by}`}
              </Typography>
            </Box>
          </AccordionSummary>
        </Accordion>
      ) : data.data.reason_data_changed === 'Workflow' ? (
        <Accordion
          disabled
          expanded={expanded === 'panel1'}
          onChange={handleChangeAccordion('panel1')}
          className="CustomAccordion-AH"
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
            <Box>
              <Stack spacing={1.5} direction="row" sx={{ alignItems: 'center', mb: 1 }}>
                <Typography variant="h6" component="div">
                  {documentDetail.data[0].tmf_document_name}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <span>{date}</span>
                </Typography>
                <Chip label={data.data.reason_data_changed} color="success" size="small" />
              </Stack>
              <Typography component="div" gutterBottom variant="body2">
                <strong>{data.data.field_changed}:</strong> {data.data.changed_data}
              </Typography>
              <Typography component="div" gutterBottom variant="body2">
                <strong>User:</strong> {data?.data?.created_by}
              </Typography>
            </Box>
          </AccordionSummary>
        </Accordion>
      ) : data.data.reason_data_changed === '' ? (
        <Accordion
          disabled
          expanded={expanded === 'panel1'}
          onChange={handleChangeAccordion('panel1')}
          className="CustomAccordion-AH"
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
            <Box>
              <Stack spacing={1.5} direction="row" sx={{ alignItems: 'center', mb: 1 }}>
                <Typography variant="h6" component="div">
                  {documentDetail.data[0].tmf_document_name}
                </Typography>
                <Typography variant="h6" gutterBottom>
                  <span>{parseFloat(documentDetail.data[0].tmf_doc_version_number).toFixed(1)}</span>
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <span>{date}</span>
                </Typography>
              </Stack>
              <Typography component="div" gutterBottom variant="body2">
                Document Downloaded
              </Typography>
              <Typography component="div" gutterBottom variant="body2">
                {/* {`User: (${userService.getUserName()})`} */}
                <strong>User:</strong> {data?.data?.created_by}
              </Typography>
            </Box>
          </AccordionSummary>
        </Accordion>
      ) : (
        ''
      )}
    </>
  );
};

export default memo(Cards);
